import api from "./index";
import { ENDPOINTS } from "./endpoints";

export const listProducts = (data)=>
  api.post(ENDPOINTS.BUYER_PRODUCTS.SEARCH,data);

export const getProductDetail = (id)=>
  api.get(ENDPOINTS.BUYER_PRODUCTS.BY_ID(id));

export const getFilters = (category = "", family = "") =>
  api.get(
    `${ENDPOINTS.BUYER_PRODUCTS.FILTERS}?category=${category}&family=${family}`
  );
